import React, { useEffect, useState } from "react";
import {
  EuiButton,
  EuiButtonEmpty,
  EuiFieldText,
  EuiForm,
  EuiFormRow,
  EuiModal,
  EuiModalBody,
  EuiModalFooter,
  EuiModalHeader,
  EuiModalHeaderTitle,
  useGeneratedHtmlId,
  EuiButtonIcon,
  EuiSpacer,
  EuiAvatar,
  EuiBadge,
} from "@elastic/eui";
import OrganizationService from "../../services/organization-service";

const SendEmailTenantValidationsModal = ({ item }) => {
  const [mail, setMail] = useState("");
  const [response, setResponse] = useState("");

  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [responseColor, setResponseColor] = useState("success");

  const modalFormId = useGeneratedHtmlId({ prefix: "modalForm" });

  const closeModal = () => setIsModalVisible(false);

  const showModal = () => setIsModalVisible(true);

  const sendEmail = async (event) => {
    event.preventDefault();
    setLoading(true);

    const token = sessionStorage.getItem("krakenT");
    const data = { tenantId: item.tenantId, email: mail };

    OrganizationService.sendValidationEmail(token, data)
      .then((response) => {
        const message =
          response.data.status === "success"
            ? response.data.data
            : "Unexpected response format";
        setResponseColor("success");
        setResponse(message);
      })
      .catch((error) => {
        const errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : "Some error occurred";

        console.error(errorMessage);
        setResponseColor("danger");
        setResponse(errorMessage);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    setMail(item.mail);
  }, [item.mail]);

  const formSample = (
    <EuiForm id={modalFormId} component="form" onSubmit={sendEmail}>
      <EuiFormRow label="Tenant Id">
        <EuiFieldText value={item.tenantId} disabled />
      </EuiFormRow>

      <EuiFormRow label="Email">
        <EuiFieldText value={mail} onChange={(e) => setMail(e.target.value)} />
      </EuiFormRow>
    </EuiForm>
  );

  let modal;

  if (isModalVisible) {
    modal = (
      <EuiModal onClose={closeModal} initialFocus="[name=popswitch]">
        <EuiModalHeader>
          <EuiModalHeaderTitle>Permissions email</EuiModalHeaderTitle>
        </EuiModalHeader>

        <EuiModalBody>
          <EuiAvatar size="s" name="Cat" imageUrl={item.companyLogo} />{" "}
          {item.nameLong}
          <EuiSpacer size="m" />
          {formSample}
          <EuiSpacer size="m" />
          {response !== "" && (
            <EuiBadge color={responseColor}>{response}</EuiBadge>
          )}
        </EuiModalBody>

        <EuiModalFooter>
          <EuiButtonEmpty onClick={closeModal}>Cancel</EuiButtonEmpty>

          <EuiButton type="submit" form={modalFormId} fill isLoading={loading}>
            Save
          </EuiButton>
        </EuiModalFooter>
      </EuiModal>
    );
  }

  return (
    <div>
      <EuiButtonIcon
        color="success"
        size="xs"
        display="base"
        iconType="email"
        aria-label="Next"
        onClick={showModal}
      />
      {modal}
    </div>
  );
};

export default SendEmailTenantValidationsModal;
